import { getSessionDuration } from 'application/session_duration'

export function formEvent(data) {
  window.dataLayer = window.dataLayer || []

  const dataEvent = {
    event: data.event,
    session_duration: getSessionDuration(),
    form_name: data.form_name,
    form_type: data.form_type,
    form_page: data.form_page
  }

  if (data.form_step) {
    dataEvent.form_step = data.form_step
    dataEvent.event_detail = data.event_detail
  }

  if (data.event == "form_field_change") {
    dataEvent.field_name = data.field_name
  }

  window.dataLayer.push(dataEvent);
}

export function formFieldChangeEvent(data) {
  window.dataLayer = window.dataLayer || []

  const dataEvent = {
    event: data.event,
    session_duration: getSessionDuration(),
    form_name: data.form_name,
    form_type: data.form_type,
    form_page: data.form_page,
    field_name: data.field_name,
    field_value: data.field_value,
    field_type: data.field_type
  }

  if (data.form_step) {
    dataEvent.form_step = data.form_step
  }

  window.dataLayer.push(dataEvent);
}
